import { RootState } from "@/store/interfaces/root";

export const state: RootState = {
  loading: false,
  csrf: {
    status: false,
    token: "",
    didInvalidate: false,
    receivedAt: 0,
    connectionError: false
  },
  banner: {
    status: false,
    component: ""
  },
  dialog: {
    status: false,
    component: ""
  },
  notification: {
    status: false,
    component: "",
    position: "top-left",
    autoDismiss: true,
    autoFocus: true,
    closable: true
  },
  alert: {
    status: false,
    component: ""
  }
};
